import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import esLocale from '@fullcalendar/core/locales/es';
import { Box, Grid, Modal, Tooltip, Typography } from '@mui/material';

//CSS
import './styles.css';
import { useEffect, useState } from 'react';
import ModalEvento from './modalEvento';
import { sendRequest } from '../../../../services/request';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { useTheme } from '@emotion/react';

const ONE_HOUR_MILISECONDS = 1000 * 60 * 60;

const Agenda = ({ pais }) => {
    const URL = process.env.REACT_APP_API_URL;
    const theme = useTheme();
    const today = new Date();
    const usuario = useSelector((state) => state.auth?.usuario);
    const [openModal, setOpenModal] = useState(false);
    const [eventos, setEventos] = useState([]);
    const [initialStart, setInitialStart] = useState(null);
    const [selectedEvent, setSelectedEvent] = useState(null);

    const [reload, setReload] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await sendRequest(
                    'get',
                    `${URL}/eventos/${usuario?.id}`,
                );
                setEventos(res.data);
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, [URL, usuario?.id, reload]);

    const handleDateClick = (value) => {
        setInitialStart(dayjs(value.dateStr));
        setOpenModal(true);
    };

    const handleClose = () => {
        setOpenModal(false);
        setSelectedEvent(null);
    };

    const handleGuardar = async (data, editar = false) => {
        try {
            if (editar) {
                delete data.id;
                await sendRequest(
                    'patch',
                    `${URL}/eventos/${selectedEvent.id}`,
                    {
                        ...data,
                    },
                );
            } else {
                await sendRequest('post', `${URL}/eventos`, {
                    ...data,
                    usuario,
                });
            }
            setReload(!reload);
            setSelectedEvent(null);
            handleClose();
        } catch (error) {
            console.log(error);
        }
    };

    const handleEventClick = (eventInfo) => {
        const evento = {
            id: eventInfo.event.id,
            title: eventInfo.event.title,
            start: dayjs(eventInfo.event.start),
            end: eventInfo.event.end ? dayjs(eventInfo.event.end) : null,
            allDay: eventInfo.event.allDay,
        };
        setOpenModal(true);
        setSelectedEvent(evento);
    };

    return (
        <Box sx={{ pt: 2 }}>
            <Grid container>
                <Grid item sm={1}></Grid>
                <Grid item sm={10}>
                    <FullCalendar
                        selectable
                        selectMirror
                        editable
                        weekNumbers
                        nowIndicator
                        height={550}
                        plugins={[
                            dayGridPlugin,
                            timeGridPlugin,
                            interactionPlugin,
                        ]}
                        initialView="timeGridWeek" //"dayGridMonth"
                        locale={esLocale}
                        aspectRatio={2.5}
                        slotLabelFormat={{
                            hour: 'numeric',
                            minute: '2-digit',
                            omitZeroMinute: false,
                            hour12: false,
                        }}
                        select={handleDateClick}
                        events={eventos}
                        scrollTime={today.getTime()}
                        selectAllow={(selectInfo) =>
                            dayjs(today).diff(selectInfo.start) <= 0
                        }
                        eventAllow={(dropInfo) =>
                            dayjs(today).diff(dropInfo.start) <= 0
                        }
                        eventClick={handleEventClick}
                        eventContent={(eventInfo) => {
                            return (
                                <Tooltip title={eventInfo.event.title}>
                                    {eventInfo.event.allDay ? (
                                        <Grid container>
                                            <Grid item xs={12}>
                                                <Typography
                                                    variant="body1"
                                                    fontSize={10}
                                                >
                                                    {`${eventInfo.event.title}`}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    ) : (
                                        <Grid conatainer>
                                            <Grid item xs={12}>
                                                <Typography
                                                    variant="body1"
                                                    fontSize={10}
                                                >
                                                    {`${dayjs(
                                                        eventInfo.event.start,
                                                    ).format('HH:mm')}
                                                    - ${dayjs(
                                                        eventInfo.event?.end,
                                                    ).format('HH:mm')}`}
                                                </Typography>
                                                <Typography
                                                    variant="body1"
                                                    fontSize={12}
                                                >
                                                    {dayjs(
                                                        eventInfo.event.end,
                                                    ).diff(
                                                        eventInfo.event.start,
                                                    ) >= ONE_HOUR_MILISECONDS
                                                        ? eventInfo.event.title
                                                        : ''}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    )}
                                </Tooltip>
                            );
                        }}
                        eventBackgroundColor={theme.palette.primary.main}
                        eventBorderColor={theme.palette.primary.main}
                    ></FullCalendar>
                </Grid>
                <Grid item sm={1}></Grid>
            </Grid>
            <Modal open={openModal}>
                <div>
                    <ModalEvento
                        start={initialStart}
                        handleClose={handleClose}
                        handleGuardar={handleGuardar}
                        event={selectedEvent}
                    />
                </div>
            </Modal>
        </Box>
    );
};

export default Agenda;
